module.exports = __webpack_public_path__ + "static/media/kredyt_14.d11b18d7.png";